let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aA5kl")).then(() => parcelRequire('9eYPk'));